import { useEffect } from 'react';
import { X } from 'lucide-react';
import {
  AnnouncementMobilePreview,
  getDisplayState,
  type PreviewData,
} from './AnnouncementMobilePreview';

interface Props {
  open: boolean;
  onClose: () => void;
  data: PreviewData;
}

const TARGET_LABEL: Record<PreviewData['targetApp'], string> = {
  BUSINESS: '비즈니스앱',
  GUARDIAN: '보호자앱',
};

export function AnnouncementPreviewModal({ open, onClose, data }: Props) {
  useEffect(() => {
    if (!open) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [open, onClose]);

  if (!open) return null;

  const displayState = getDisplayState(data.displayStartAt, data.displayEndAt);

  return (
    <div
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
      onClick={onClose}
    >
      <div
        className="flex max-h-[90vh] w-full max-w-[420px] flex-col rounded-2xl bg-white shadow-2xl"
        onClick={e => e.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b border-gray-200 px-4 py-3">
          <div className="flex items-center gap-2">
            <h3 className="text-sm font-semibold text-gray-900">
              모바일 미리보기
            </h3>
            <span className="rounded bg-gray-100 px-2 py-0.5 text-[11px] font-medium text-gray-600">
              {TARGET_LABEL[data.targetApp]}
            </span>
            <span className={`text-[11px] font-medium ${displayState.tone}`}>
              · {displayState.label}
            </span>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="닫기"
            className="rounded p-1 text-gray-500 hover:bg-gray-100"
          >
            <X size={18} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto bg-[#ECECEC] p-4">
          <AnnouncementMobilePreview data={data} framed />
          <p className="mt-3 text-center text-[11px] text-gray-500">
            실제 앱 화면과 거의 동일하게 표시됩니다.
          </p>
        </div>
      </div>
    </div>
  );
}
